/*
 * Reducer actions related with login
 */
import * as types from './types';

export function persistLogin(email, password) {
  return {
    type: types.PERSIST_LOGIN,
    email,
    password
  };
}
export function requestLogin(email, password) {
  return {
    type: types.LOGIN_REQUEST,
    email,
    password
  };
}

export function loginFailed(error) {
  return {
    type: types.LOGIN_FAILED,
    error
  };
}

export function onLoginResponse(userDetail) {
  return {
    type: types.LOGIN_RESPONSE,
    userDetail
  };
}

export function requestResetPassword(email) {
  return {
    type: types.RESET_PASSWORD_REQUEST,
    email
  };
}
export function resetPasswordFailed(error) {
  return {
    type: types.RESET_PASSWORD_FAILED,
    error
  };
}

export function onResetPasswordResponse(response) {
  return {
    type: types.RESET_PASSWORD_RESPONSE,
    response
  };
}

export function requestResetPasswordConfirm(email, code, newPassword) {
  return {
    type: types.RESET_PASSWORD_CONFIRM_REQUEST,
    email,
    code,
    newPassword
  };
}
export function resetPasswordConfirmFailed(error) {
  return {
    type: types.RESET_PASSWORD_CONFIRM_FAILED,
    error
  };
}

export function onResetPasswordConfirmResponse() {
  return {
    type: types.RESET_PASSWORD_CONFIRM_RESPONSE,
    newPassword: '',
    code: ''
  };
}

export function clearError() {
  return {
    type: types.CLEAR_ERROR
  };
}
